import React from "react";

const CustomLinkButton = ({ title, onClick, fontSize = 16 }) => {
  return (
    <div
      className="custom_link_button"
      onClick={onClick}
      style={{ fontSize: fontSize }}
    >
      {title}
    </div>
  );
};

export default CustomLinkButton;
